module.exports = __webpack_public_path__ + "static/media/edit.24452ad9.svg";